var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3333 40.3333L41.3333 25.4167L29.5833 37.1667L44.4999 52.0833L56.3333 40.3333ZM33.3333 87.5H8.33325V104.167H33.3333V87.5ZM108.333 4.58334H91.6666V29.1667H108.333V4.58334V4.58334ZM170.417 37.1667L158.667 25.4167L143.75 40.3333L155.5 52.0833L170.417 37.1667ZM143.667 151.333L158.583 166.333L170.333 154.583L155.333 139.667L143.667 151.333ZM166.667 87.5V104.167H191.667V87.5H166.667ZM99.9999 45.8333C72.4166 45.8333 49.9999 68.25 49.9999 95.8333C49.9999 123.417 72.4166 145.833 99.9999 145.833C127.583 145.833 150 123.417 150 95.8333C150 68.25 127.583 45.8333 99.9999 45.8333ZM91.6666 187.083H108.333V162.5H91.6666V187.083ZM29.5833 154.5L41.3333 166.25L56.2499 151.25L44.4999 139.5L29.5833 154.5Z",
    fill: "#FFEC65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.0a47e81e48ff91bcc3811085bd34d419.svg";
export { ForwardRef as ReactComponent };